import React from "react";

import { useLocation } from "react-router-dom";
import cx from "classnames";
import { findIndex, size } from "lodash";
import propTypes from "prop-types";

import Button, { BUTTON_TYPES } from "../button/Button";
import MusicPlayer from "../musicPlayer";
import SearchBar from "../searchBar/SearchBar";
import SideDrawer from "../sideDrawer/SideDrawer";
import { ICONS } from "../../constants/icons.constants";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import playlistStore from "../../zustand/playlist.store";
import { appActions } from "../../actions";
import userStore from "../../zustand/user.store";
import likedSongsStore from "../../zustand/likedSong.store";
import SchedulesStore from "../../zustand/Schedule.store";
import ignoredSongStore from "../../zustand/ignoreSong.store";
import favoriteSongStore from "../../zustand/favoriteSong.store";
import disLikedSongsStore from "../../zustand/dislikedSong.store";
import { showToaster } from "../../helpers/toaster.helpers";

import styles from "./appSkeleton.module.scss";

const AppSkeleton = (props) => {
  const { children, hidePlayer = false, restrictedMode = false } = props;

  const currentRoute = useLocation();

  const { user, setUser, userOffline } = userStore((state) => ({
    user: state.user,
    setUser: state.setUser,
    userOffline: state.userOffline,
  }));
  const {
    setSongs: setMusicPlayerSongs,
    setPlayList,
    toggleIsShuffle,
    playList,
  } = musicPlayerStore((state) => ({
    setSongs: state.setSongs,
    setPlayList: state.setPlayList,
    toggleIsShuffle: state.toggleIsShuffle,
    playList: state.playList,
  }));
  const { setPlaylists } = playlistStore((state) => ({
    setPlaylists: state.setPlaylists,
  }));
  const { setSongs: setLikedSongs } = likedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setDislikeSongs } = disLikedSongsStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setIgnoredSongs } = ignoredSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSongs: setFavouriteSongs } = favoriteSongStore((state) => {
    return {
      setSongs: state.setSongs,
    };
  });
  const { setSchedules } = SchedulesStore((state) => ({
    setSchedules: state.setSchedules,
  }));

  const songs = playList?.songs || [];

  const [isLoading, setIsLoading] = React.useState(false);

  const handleRefresh = async () => {
    if (userOffline) {
      return showToaster(
        "error",
        "You are offline, please check your internet connection"
      );
    }
    setIsLoading(true);
    const appData = await appActions.fetchAppData(user.id || "", userOffline);

    const {
      user: userData,
      playlists,
      status,
      likedSongs,
      ignoredSongs,
      favouriteSongs,
      dislikedSongs,
      schedules,
      songs,
      favoritePlaylist,
    } = appData;

    const index = findIndex(
      favoritePlaylist.songs,
      (song) => song.id === status.last_played_song
    );

    setUser(userData);
    setPlaylists(playlists);
    setLikedSongs(likedSongs);
    setDislikeSongs(dislikedSongs);
    setFavouriteSongs(favouriteSongs);
    setSchedules(schedules);
    setMusicPlayerSongs(songs);
    setIgnoredSongs(ignoredSongs);
    setPlayList(favoritePlaylist, index);
    toggleIsShuffle(status.last_shuffled);

    // const { value: songsData } = songsResponse;

    // const ingoreSongIds = getIngoreSongIds(playlists);
    // setIgnoredSongs(ingoreSongIds);
    // setPlaylists(playlists);
    // setMusicPlayerSongs(getFormattedSongs(playlists?.[0]?.songs || []));
    // setPlayList(playlists?.[0]);
    setIsLoading(false);
  };

  return (
    <div
      className={cx(styles.container, {
        [styles.homepage]: currentRoute.pathname === "/",
        [styles.noPlayer]: hidePlayer,
      })}
    >
      <div className={styles.bodyContainer}>
        <SideDrawer restrictedMode={restrictedMode} />
        <div className={styles.rightContainer}>
          {!restrictedMode && (
            <div className={styles.searchBar}>
              <SearchBar />
              {currentRoute.pathname === "/" && (
                <Button
                  type={BUTTON_TYPES.TERTIARY}
                  onClick={handleRefresh}
                  className={styles.btn}
                  hasIcon
                  iconType={ICONS.REFRESH}
                  isLoading={isLoading}
                  disabled={userOffline}
                >
                  Refresh
                </Button>
              )}
            </div>
          )}

          <div
            className={cx(styles.childrenContainer, {
              [styles.fullHeight]: restrictedMode,
            })}
          >
            {children}
          </div>
        </div>
      </div>
      {!hidePlayer && (
        <div className={styles.footerContainer}>
          <MusicPlayer />
        </div>
      )}
    </div>
  );
};

AppSkeleton.propTypes = {
  children: propTypes.element,
  hidePlayer: propTypes.bool,
  restrictedMode: propTypes.bool,
};

AppSkeleton.defaultProps = {
  children: <></>,
  hidePlayer: false,
  restrictedMode: false,
};

export default AppSkeleton;
